import { utilityMutations } from "../../../../../Core/Global/Store/utility";
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

export const state = {
    activeObituary: null,
    activeFilterType: 'birth',
    dateFrom: '',
    dateTo: '',
    searchModel: '',
    activePage: 1,
    itemsPerPage: 10,
    obituaries: {},
    funerals: {},
    biographies: {},
    isLoading: true,
    hcpatchaSiteKey: null
}

export const getters = {
    getFormattedDate: (state) => (date) => {
        if (dayjs(date).isValid()) return dayjs(date).format('MMMM D, YYYY');
        return "—";
    },
    getFormattedTime: (state) => (time) => {
        if (time) return dayjs('2000-01-01' + time).format('h:mm A');
        return "—";
    },
    getFormattedAddress: (state) => (obj) => {
        if (typeof obj == 'string') obj = JSON.parse(obj);
        if (!obj || typeof obj !== 'object' || Object.keys(obj).length === 0) return false;
        let someAddressExists = ["address1","address2","address3","address4","city","state","zip"].some(p=>obj[p]);
        let someCityStateZipExists = ["city","state","zip"].some(p=>obj[p]);
        let string = '';

        if (someAddressExists) string += `${obj.address1 || ''}${obj.address2 ? ', ' + obj.address2 : ''}${obj.address3 ? ', ' + obj.address3 : ''}${obj.address4 ? ', ' + obj.address4 : ''}`;
        if (someCityStateZipExists) {
            if (someAddressExists) string += ',<br>';
            string += `${obj.city || ''}${obj.state ? ', ' + obj.state : ''}${obj.zip ? ' ' + obj.zip : ''}`;
        }

        return string || false;
    },
    getServiceDateText: (state) => (service) => {
        let result = "";
        if (service.date) {
            if (service.show_day_of_week) result = `${dayjs(service.date).format("dddd")}, `;
            result += dayjs(service.date).format("MMMM D, YYYY")
        }

        return result;
    },
    getServiceTimeText: (state, getters) => (service) => {
        let start  = service.start_time,
            end    = service.end_time,
            result = "";

        if (!start && !end) return;

        if (start && end) {
            result = `From ${getters.getFormattedTime(start)} to ${getters.getFormattedTime(end)}`;
        } else if (start) {
            result = `Starting at ${getters.getFormattedTime(start)}`;
        } else if (end) {
            result = `Ending at ${getters.getFormattedTime(end)}`;
        }

        return result;
    },
    totalItems: (state, getters) => {
        return getters.filteredList.length;
    },
    getObituariesFromIdArray: state => (array) => {
        let obituaries = {}
        array.forEach(id => obituaries[id] = state.obituaries[id]);
        return obituaries;
    },
    // Paginate Object based on active page and items per page
    paginateObject: state => (array) => {
        return array.reduce((a,c,i) => {
            if (i >= ((state.activePage - 1) * state.itemsPerPage) && i < (state.activePage * state.itemsPerPage)) a.push(c);
            return a;
        }, []);
    },
    searchedList: (state) => {
        if (!state.searchModel) return state.obituaries;

        return state.obituaries.filter(o => {
            // Split into multiple searches, space delimited, filter out empty strings
            let splitSearch = state.searchModel.split(" ").filter(p => p);

            // Look through split strings and return matches where both parts are found in the result
            return splitSearch.every(p => {
                return (o.name+o.content).toLowerCase().includes(p.toLowerCase())
            })
        });
    },
    filteredList: (state, getters) => {
        let prevArr    = getters.searchedList,
            filterProp = `date_of_${state.activeFilterType}`,
            from       = dayjs(state.dateFrom),
            to         = dayjs(state.dateTo);

        if (!state.dateFrom && !state.dateTo) return prevArr;
        if (!state.dateTo) return prevArr.filter(o => dayjs(o[filterProp]).isAfter(from));
        if (!state.dateFrom) return prevArr.filter(o => dayjs(o[filterProp]).isBefore(to));
        return prevArr.filter(o => dayjs(o[filterProp]).isBetween(from, to));
    },
    paginatedList: (state, getters) => {
        return getters.paginateObject(getters.filteredList);
    }
}

export const mutations = {
    ...utilityMutations
}

export const actions = {
    setView({ commit }, value) {
        commit('SET', ['activeView', value || 'obituary-listing'])
    },
    setPage({ commit }, value) {
        commit('SET', ['activePage', value]);

        // Scroll to the top of the component accounting for the header's height
        let yPos = document.querySelector('#obituary-module').getBoundingClientRect().top + window.pageYOffset - parseInt(document.body.style.getPropertyValue('--hd-height'), 10);
        window.scrollTo({top:yPos})
    },
    setObituaries({ commit }, value) {
        if (value) commit('SET', ['obituaries', value]);
        commit('SET', ['isLoading', false]);
    },
    setActiveObituary({ commit }, value) {
        commit('SET', ['activeObituary', value || null]);
    },
    setHcaptchaSiteKey({ commit }, value) {
        commit('SET', ['hcaptchaSiteKey', value || null]);
    },
    setLoading({commit}, value) {
        commit('SET', ['isLoading', value]);
    }
}

export default { namespaced: true, state, getters, mutations, actions };